// src/utils/initialization.factory.ts
import { inject, PLATFORM_ID } from "@angular/core";
import { Router, Routes } from "@angular/router";
import { isPlatformBrowser } from "@angular/common";
import { InitializationService } from "./initialization.service";
import { RoleService } from "src/app/Authentication/services/role.service";
import { MAIN_LAYOUT_ROUTES } from "src/app/Main-layout/main-layout";


export function initializeApp(
    initService: InitializationService,
    router: Router,
    rolesService: RoleService,
    platformId: Object
) {
    return (): Promise<void> => {
        return initService.InitBaseUrl().then(() => {
            // Only run routing logic in the browser after config is loaded
            if (isPlatformBrowser(platformId)) {
                let role: string | undefined;
                const currentUser = localStorage?.getItem("currentUser");

                if (currentUser) {
                    try {
                        const user = JSON.parse(currentUser);
                        role = rolesService.getDecodedTokenInfo(user.token)?.roles[0];
                    } catch (e) {
                        console.error("Failed to parse user session", e);
                    }
                }

                const currentUrl = initService.getCurrentUrl() || window.location.host;

                const isSpecialDomain =
                    currentUrl.includes("seller") ||
                    currentUrl.includes("wholesaler") ||
                    currentUrl.includes("cms") ||
                    ["localhost:4500", "localhost:4700", "localhost:4000"].some(host => currentUrl.includes(host));

                let newRoutes: Routes;

                if (isSpecialDomain) {
                    const redirectPath = (role === "WholeSaler" || role === "Vendor")
                        ? "vendor/dashboard"
                        : "auth/my-account";

                    newRoutes = [
                        { path: "", redirectTo: redirectPath, pathMatch: "full" },
                        { path: "auth", redirectTo: redirectPath, pathMatch: "full" },
                        { path: "", loadChildren: () => MAIN_LAYOUT_ROUTES },
                        { path: "**", redirectTo: "error/not-found" },
                    ];
                } else {
                    newRoutes = [
                        { path: "", redirectTo: "home/main-dashboard", pathMatch: "full" },
                        { path: "", loadChildren: () => MAIN_LAYOUT_ROUTES },
                        { path: "**", redirectTo: "error/not-found" },
                    ];
                }

                // Apply the routes and refresh navigation
                router.resetConfig(newRoutes);
            }
        }).catch(err => {
            console.error("Initialization failed:", err);
            // Resolve the promise anyway so the app can bootstrap and show the error page
            // (The service has already triggered a navigation to access-denied)
        });
    };
}
